if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
} // ← これで if を閉じる

/* ===== 2L以上選択時だけ「公式サイト限定価格」を表示（安定版） ===== */
(() => {
  const OPTION_NAME = 'リッター数';
  const MIN_LITERS = 2;

  // 初期は必ず隠す（CSSと二重ロック）
  document.querySelectorAll('[id^="site-only-badge-"]').forEach(b => (b.hidden = true));

  // 全角→半角しつつ数値抽出
  function toNumber(text){
    if(!text) return 0;
    const half = text.replace(/[０-９．]/g, s => (s === '．' ? '.' : String.fromCharCode(s.charCodeAt(0)-65248)));
    const m = half.match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function getValue(section){
    // legend が「リッター数」の fieldset を探す（DawnのボタンUI対応）
    const fs = [...section.querySelectorAll('fieldset')]
      .find(x => (x.querySelector('legend')?.textContent || '').trim() === OPTION_NAME);
    if(!fs) return '';

    const active = fs.querySelector('label.is-active,[aria-pressed="true"]');
    if(active) return active.textContent.trim();

    const checked = fs.querySelector('input[type="radio"]:checked');
    if(checked) return checked.value.trim();

    const sel = fs.querySelector('select');
    if(sel) return sel.value.trim();

    return '';
  }

  function shouldShow(badge){
    const section = badge.closest('[data-section],[data-section-id]') || document;
    const n = toNumber(getValue(section));
    return n >= MIN_LITERS;
  }

  function render(){
    document.querySelectorAll('[id^="site-only-badge-"]').forEach(badge => {
      badge.hidden = !shouldShow(badge);
    });
  }

  // 初期 & 各種イベント
  ['DOMContentLoaded','variant:change','shopify:section:load','shopify:section:select'].forEach(ev =>
    document.addEventListener(ev, render)
  );
  document.body.addEventListener('change', render);
  new MutationObserver(render).observe(document.body, { childList:true, subtree:true });
})();
